(function () {
  'use strict';

  /* Progressive enhancement only — the track scrolls and swipes
     natively via CSS scroll-snap with JS disabled. */

  function initSection(sectionEl) {
    if (!sectionEl) return;

    var carousel = sectionEl.querySelector('.cwc_db01-hero__carousel');
    if (!carousel) return;

    var track = carousel.querySelector('[data-cwc-track]');
    if (!track) return;

    var slides = track.querySelectorAll('.cwc_db01-hero__slide');
    if (slides.length < 2) return;

    var prevArrow = carousel.querySelector('[data-cwc-arrow="prev"]');
    var nextArrow = carousel.querySelector('[data-cwc-arrow="next"]');
    var dotsWrap = carousel.querySelector('[data-cwc-dots]');
    var dots = [];

    function currentIndex() {
      var width = slides[0].offsetWidth;
      if (!width) return 0;
      return Math.round(track.scrollLeft / width);
    }

    function goTo(index) {
      var max = slides.length - 1;
      var target = Math.max(0, Math.min(index, max));
      track.scrollTo({ left: slides[0].offsetWidth * target, behavior: 'smooth' });
    }

    function syncState() {
      var index = currentIndex();
      dots.forEach(function (dot, i) {
        dot.classList.toggle('cwc_db01-hero__dot--active', i === index);
      });
      if (prevArrow) prevArrow.disabled = index === 0;
      if (nextArrow) nextArrow.disabled = index === slides.length - 1;
    }

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      slides.forEach(function (slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'cwc_db01-hero__dot';
        dot.setAttribute('aria-label', 'Show image ' + (i + 1));
        dot.addEventListener('click', function () {
          goTo(i);
        });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
      dotsWrap.removeAttribute('aria-hidden');
    }

    if (prevArrow) {
      prevArrow.hidden = false;
      prevArrow.addEventListener('click', function () {
        goTo(currentIndex() - 1);
      });
    }

    if (nextArrow) {
      nextArrow.hidden = false;
      nextArrow.addEventListener('click', function () {
        goTo(currentIndex() + 1);
      });
    }

    track.addEventListener('scroll', function () {
      window.clearTimeout(track._cwcScrollTimer);
      track._cwcScrollTimer = window.setTimeout(syncState, 80);
    }, { passive: true });

    syncState();
  }

  function initAllSections() {
    document.querySelectorAll('.cwc_db01-hero').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.cwc_db01-hero');
    if (section) initSection(section);
  });
})();
